// TODO: add back
// import styled from 'styled-components';
// import { launcherElementInfo } from '../../../../info/launcherElementInfo';
// import { DropdownInput } from '../../baseInputs/DropdownInput';
// import { useScene } from '../../../../context/sceneContext';

export const TargetVariableInput = () => {
  // const scene = useScene();
  // const targetVariablesInfo = launcherElementInfo.targetVariableInput.targetVariables;
  // const targetVariableOptions = targetVariablesInfo
  //   ? Object.keys(targetVariablesInfo).map((targetVariable) => ({
  //     label: targetVariablesInfo[targetVariable],
  //     value: targetVariable,
  //   }))
  //   : [];

  // const data = scene.getSelectedElementsData(
  //   {
  //     targetVariable: undefined,
  //   },
  //   'props'
  // );

  return (null
    // <Row>
    //   <DropdownInput
    //     label="Target"
    //     value={data.targetVariable}
    //     options={targetVariableOptions}
    //     onChange={(newValue) =>
    //       scene.updateSelectedElementsData({ targetVariable: newValue }, 'props', 'targetVariableInput')
    //     }
    //     canBeCleared={false}
    //     isSearchable={false}
    //   />
    // </Row>
  )
};

// const Row = styled.div`
//   width: 100%;
//   display: flex;
// `;
